@if (update.visible()) {
<section class="update-prompt" aria-labelledby="update-prompt-title" aria-describedby="update-prompt-description">
  <div class="update-icon" aria-hidden="true"><i class="pi pi-refresh"></i></div>
  <div class="update-content">
    <div role="status" aria-live="polite" aria-atomic="true">
      <h2 id="update-prompt-title">{{ 'common.updatePrompt.title' | translate }}</h2>
      <p id="update-prompt-description">{{ 'common.newVersionAvailable' | translate }}</p>
    </div>
    <p class="update-countdown" role="timer" aria-live="off">
      @if (update.paused()) {
      {{ 'common.updatePrompt.paused' | translate }}
      } @else {
      {{ 'common.updatePrompt.countdown' | translate : { seconds: update.secondsRemaining() } }}
      }
    </p>
    <div class="update-actions">
      <button type="button" class="refresh-button" (click)="update.refresh()">
        {{ 'common.updatePrompt.refresh' | translate }}
      </button>
      <button type="button" class="pause-button" [disabled]="update.paused()" (click)="update.pause()">
        {{ 'common.updatePrompt.pause' | translate }}
      </button>
    </div>
  </div>
</section>
}
